import s from './CardModal.module.css';
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import musicPlayerPng from'../../asset/music-player.png';
import {SoundPlayer} from'../SoundPlayer';
import {RedButton, BlueButton, GreenButton} from '../MyButton';
import {Form} from 'react-bootstrap';
import {postData} from '../../middleware/apiMiddleware';

export default function CardModal ({rawItem, item, setItem}){		
	const navigate = useNavigate();
	
	const [replacedImg, setReplacedImg] = useState();
	const [replacedImgUrl, setReplacedImgUrl] = useState();
	
	const updateCard = () => {
		if (hasDifference(rawItem.detail, item.detail, "level", "question")) {
			let obj = {
				itemId:item.id,
				level:item.detail.level,
				question:item.detail.question,
			};
			postData("cardApi/updateCard", obj, navigate);
		}
		
		console.log("trigger2");
		let answersNew = [];
		let answersUpdate = [];
		
		let answerMaps = {};		
		let answerIds = [];
		
		let tmp = item.detail.answers;
		for(let i=0; i< tmp.length; i++) {
			
			if (tmp[i].id) {
				answerIds.push(tmp[i].id);
				answerMaps[tmp[i].id] = tmp[i];
			} else {
				answersNew.push(tmp[i]);
			}
		}
		
		tmp = rawItem.detail.answers;
		for(let i=0; i< tmp.length; i++) {
			if (!answerMaps[tmp[i].id]) {
				answersUpdate.push({
					id:tmp[i].id,
					softDeleted:1,
				});
			} else {
				let obj = {
					id:tmp[i].id,
				}
				let canPush = false;
				if (hasDifference(answerMaps[tmp[i].id], tmp[i], "ordering")) {
					obj.ordering = answerMaps[tmp[i].id].ordering;
					canPush = true;
				}
				if (hasDifference(answerMaps[tmp[i].id], tmp[i], "sentence")) {
					obj.ordering = answerMaps[tmp[i].id].ordering;
					obj.sentence = answerMaps[tmp[i].id].sentence;
					canPush = true;
				}
				
				if (canPush) {
					answersUpdate.push(obj);
				}
			}
		}
		
		if (answersNew.length > 0) {
			postData("cardApi/addCardAnswers", {itemId:item.id, answersNew}, navigate); 
		}
		
		if (answersUpdate.length > 0) {
			postData("cardApi/updateCardAnswers", {itemId:item.id, answersUpdate}, navigate); 
		}
		
		let hintsNew = [];
		let hintsUpdate = [];
		
		let hintMaps = {};		
		let hintIds = [];
		
		tmp = item.detail.hints;
		for(let i=0; i< tmp.length; i++) {
			
			if (tmp[i].id) {
				hintIds.push(tmp[i].id);
				hintMaps[tmp[i].id] = tmp[i];
			} else {
				hintsNew.push(tmp[i]);
			}
		}
		
		tmp = rawItem.detail.hints;
		for(let i=0; i< tmp.length; i++) {
			if (!hintMaps[tmp[i].id]) {
				hintsUpdate.push({
					id:tmp[i].id,
					softDeleted:1,
				});
			} else {
				let obj = {
					id:tmp[i].id,
				}
				let canPush = false;
				if (hasDifference(hintMaps[tmp[i].id], tmp[i], "ordering")) {
					obj.ordering = hintMaps[tmp[i].id].ordering;
					canPush = true;
				}
				if (hasDifference(hintMaps[tmp[i].id], tmp[i], "sentence")) {
					obj.ordering = hintMaps[tmp[i].id].ordering;
					obj.sentence = hintMaps[tmp[i].id].sentence;
					canPush = true;
				}
				
				if (canPush) {
					hintsUpdate.push(obj);
				}
			}
		}
		
		if (hintsNew.length > 0) {
			postData("cardApi/addCardHints", {itemId:item.id, hintsNew}, navigate); 
		}
		
		if (hintsUpdate.length > 0) {
			postData("cardApi/updateCardHints", {itemId:item.id, hintsUpdate}, navigate); 
		}
	}
	
	const hasDifference = (st, nd, ...fields) => {
		for(let i=0; i<fields.length; i++ ) {
			if (!(st[fields[i]] !== 'undefined') || !(nd[fields[i]] !== 'undefined') || st[fields[i]] != nd[fields[i]]) {
				return true;
			}
		}
		return false;
	}		
	
	const canUpdate = () => {
		if (replacedImgUrl) {
			return true;
		}
		
		if (hasDifference(rawItem.detail, item.detail, "level", "question")) {
			return true;
		}
		
		if (rawItem.detail.answers.length != item.detail.answers.length) {
			return true;
		} 
		
		for(let i=0; i< rawItem.detail.answers.length; i++) {
			if (hasDifference(rawItem.detail.answers[i], item.detail.answers[i], "ordering", "sentence")) {
					return true;
			}
		}
		
		if (rawItem.detail.hints.length != item.detail.hints.length) {
			return true;
		}
		
		for(let i=0; i< rawItem.detail.hints.length; i++) {
			if (hasDifference(rawItem.detail.hints[i], item.detail.hints[i], "ordering", "sentence")) {
				return true;
			}
		}
		return false;
	}
	
	const addAnswer = () => {
		let tmp = {...item.detail};
		tmp.answers.push({
			ordering: item.detail.answers.length,
			sentence:""
		})
		
		setItem({...item, ['detail']:tmp} )
	}
	
	const addHint = () => {
		let tmp = {...item.detail};
		tmp.hints.push({
			ordering: item.detail.hints.length,
			sentence:""
		})
		
		setItem({...item, ['detail']:tmp} )
	}
	
	useEffect(() => {
		setReplacedImg(null);
		setReplacedImgUrl(null);
	}, [rawItem]);
	
	return (
		<div onPaste={e=>{
				let isImg = false;
				var items = (e.clipboardData || e.originalEvent.clipboardData).items;							
				
				for (let i in items) {
					var item = items[i];
						if (item.kind === 'file') {
							var blob = item.getAsFile();				
							setReplacedImg(blob);
							let link = URL.createObjectURL(blob);
							setReplacedImgUrl(link);
							console.log(link);
							isImg = true;
						}
					
				}
				if (isImg) {
					e.preventDefault();
				}
			}}>
			<div className={s.section1}>
				<div className={[s.s1Img, (replacedImgUrl) ? s.s1ImgUpdated : ""].join(" ")}>
					<img className={s.imgPath} src={(replacedImgUrl) ? replacedImgUrl : item.detail.imgPath}  alt="icon"/>
					<div>drop file or paste image</div>
				</div>
				<div className={s.s1Data}>
					
					<div className={s.s1Datarow}>
						<div className={s.label}>Level</div>
						<div className={s.s1LevelSelector}>
							<Form.Select value={item.detail.level} onChange={(e)=>{
									let tmp = {...item.detail};
									tmp.level = e.target.value;
									setItem({...item, ['detail']:tmp} )
								}}>
								<option value="Seeding">Seeding</option>
								<option value="Budding">Budding</option>
								<option value="Blossom">Blossom</option>
								<option value="Explorer">Explorer</option>
								<option value="Voyager">Voyager</option>
								<option value="Navigator">Navigator</option>
								<option value="Trailblazer">Trailblazer</option>
							</Form.Select>
						</div>
					</div>
					<div className={s.s1Datarow}>
						<div className={s.label}>Question
						</div>
						<div className={s.s1Question}>
							
							<Form.Control type="text" value={item.detail.question} onChange={e=>{
									let tmp = {...item.detail};
									tmp.question = e.target.value;
									setItem({...item, ['detail']:tmp} )
								}}
							/>
							
							
						</div>
						<div className={s.soundPlayer}><SoundPlayer soundFile={item.detail.questionSoundTrack}/>UK</div>
						<div className={s.soundPlayer}><SoundPlayer soundFile={item.detail.questionSoundTrackUs}/>US</div>
					</div>
				</div>
			</div>
		
			<div className={s.sectionR}>
				<div>
					<div className={s.label}>Answers</div>
					<RedButton isEnabled = {true} clickedAction={addAnswer}  bText="+" />
				</div>
				{
					item.detail.answers.map((a, indexA)=>(<div className={s.s2AnswerRow} key={"s-" + indexA}>
						
						<Form.Control className={s.inputNumberBox} type="number" value={a.ordering} min="0" onChange={e=>{
								let tmp = {...item.detail};
								tmp.answers[indexA].ordering = e.target.value;
								setItem({...item, ['detail']:tmp} )
							}}
						/>
					
						<Form.Control className={s.inputSentenceBox}  type="text" value={a.sentence} onChange={e=>{
								let tmp = {...item.detail};
								tmp.answers[indexA].sentence = e.target.value;
								setItem({...item, ['detail']:tmp} )
							}}
						/>
						
						<div className={s.soundPlayer}>{a.soundTrack && (<><SoundPlayer soundFile={a.soundTrack}/>UK</>)}</div>
						<div className={s.soundPlayer}>{a.soundTrack && (<><SoundPlayer soundFile={a.soundTrackUs}/>US</>)}</div>
						
					</div>))
					
				}
			</div>
		
			<div className={s.sectionR}>
				<div>
					<div className={s.label}>Hints</div>
					<RedButton isEnabled = {true} clickedAction={addHint}  bText="+" />
				</div>
				{
					item.detail.hints.map((h, indexH)=>(<div className={s.s2AnswerRow} key={"h-" + indexH}>
						
						<Form.Control className={s.inputNumberBox} type="number" value={h.ordering} min="0" onChange={e=>{
								let tmp = {...item.detail};
								tmp.hints[indexH].ordering = e.target.value;
								setItem({...item, ['detail']:tmp} )
							}}
						/>
					
					
						<Form.Control className={s.inputSentenceBox}  type="text" value={h.sentence} onChange={e=>{
								let tmp = {...item.detail};
								tmp.hints[indexH].sentence = e.target.value;
								setItem({...item, ['detail']:tmp} )
							}}
						/>
						
						<div className={s.soundPlayer}><SoundPlayer soundFile={h.soundTrack}/>UK</div>
						<div className={s.soundPlayer}><SoundPlayer soundFile={h.soundTrackUs}/>US</div>
						
					</div>))
					
				}
				<div></div>
			</div>
			<div><RedButton isEnabled = {canUpdate()} clickedAction={updateCard}  bText="Update?" /></div>
		{/*
			<div>{item.detail.level}</div>
			<div>
				<input type="text" value={item.detail.question} onChange={e=>{
							let tmp = {...item.detail};
							tmp.question = e.target.value;
							setItem({...item, ['detail']:tmp} )
						}}
					/>
			</div>
			<div className={s.imgPath}><img src={item.detail.imgPath}  alt="icon"/></div>
			<div><SoundPlayer soundFile={item.detail.questionSoundTrack}/>UK</div>
			<div><SoundPlayer soundFile={item.detail.questionSoundTrackUs}/>US</div>
			<div>
			{
				item.detail.answers.map((a)=>(<div key={a.ordering}>{a.sentence}</div>))
				
			}
			</div>
			<div>
			{
				item.detail.hints.map((h)=>(<div key={h.ordering}>{h.sentence}</div>))
				
			}
</div>*/}
			
		</div>);
}